import "./ProgressBarSchemaFormComponent.scss";

type Props = {
    value: number | null | undefined;
};

export const ProgressBarSchemaFormComponent = ({ value }: Props) => {
    const isIndeterminate = value == null;
    const clampedFraction = isIndeterminate ? 0 : Math.min(1, Math.max(0, value));

    return (
        <div className="SchemaFormProgressBar" aria-valuemin={0} aria-valuemax={1}>
            <div className="SchemaFormProgressBar__track">
                {isIndeterminate ? (
                    <div className="SchemaFormProgressBar__indeterminate" aria-hidden="true" />
                ) : (
                    <div
                        className="SchemaFormProgressBar__fill"
                        style={{ width: `${clampedFraction * 100}%` }}
                        aria-valuenow={clampedFraction}
                    />
                )}
            </div>
        </div>
    );
};
